import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header">
      <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>
        <h1>🎰 LottoLab</h1>
      </Link>
      
      <nav className="header-nav">
        <Link to="/" className={isActive('/') ? 'active' : ''}>
          Dashboard
        </Link>
        <Link to="/estrazioni" className={isActive('/estrazioni') ? 'active' : ''}>
          Estrazioni
        </Link>
        <Link to="/statistiche" className={isActive('/statistiche') ? 'active' : ''}>
          Statistiche
        </Link>
        <Link to="/generatore" className={isActive('/generatore') ? 'active' : ''}>
          Generatore
        </Link>
        <Link to="/ipotesi" className={isActive('/ipotesi') ? 'active' : ''}>
          Ipotesi
        </Link>
        <Link to="/giocate" className={isActive('/giocate') ? 'active' : ''}>
          Giocate
        </Link>
        <Link to="/alert" className={isActive('/alert') ? 'active' : ''}>
          Alert
        </Link>
        <Link to="/sistemi-ridotti" className={isActive('/sistemi-ridotti') ? 'active' : ''}>
          Sistemi
        </Link>
        <Link to="/confronto-ruote" className={isActive('/confronto-ruote') ? 'active' : ''}>
          Confronto
        </Link>
        {user?.is_admin && (
          <Link to="/admin" className={isActive('/admin') ? 'active' : ''}>
            Admin
          </Link>
        )}
        
        <div className="user-menu">
          <button 
            className="user-btn"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            👤 {user?.username}
          </button>
          
          {showDropdown && (
            <div className="user-dropdown">
              <Link to="/profilo" onClick={() => setShowDropdown(false)}>
                Profilo
              </Link>
              <button onClick={() => { logout(); setShowDropdown(false); }}>
                Logout
              </button>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
